module.exports = __webpack_public_path__ + "img/call-incoming.0e3d9d2f.svg";